//pages
import { ReportManagement } from 'pages/reports';

import { useProviderManagementData } from 'pages/reports/components/useProviderManagementData';

export const ProviderReportManagement = () => {
  const {
    reports,
    sites,
    providers,
    remittances,
    submissions,
    payors,
    totalReports,
    isLoading,
    isError,
    isFetching,
    errorMessage,
    refetchReports,
    pagination,
    setPagination,
  } = useProviderManagementData();

  return (
    <ReportManagement
      reports={reports}
      sites={sites}
      remittances={remittances}
      providers={providers}
      submissions={submissions}
      payors={payors}
      isError={isError}
      isLoading={isLoading}
      isFetching={isFetching}
      totalReports={totalReports}
      pagination={pagination}
      setPagination={setPagination}
      refetchReports={refetchReports}
      errorMessage={errorMessage}
    />
  );
};
